module.exports = __webpack_public_path__ + "img/public-mooring.d5a4a05d.webp";